Pixlee.module('Concerns', function(Concerns, App, Backbone, Marionette, $) {

    Concerns.perfectMosaicHelpers = {
        calculatePhotoSizes: function(totalSmallGridWidth) {
            // Remove the queue model if in the collection
            var queueModel = this.collectionQueue.findWhere({
                'queueModel': true
            });
            this.collectionQueue.remove(queueModel);

            // Calculate small grid width and large photo per row
            var smallGridWidth = Math.floor(totalSmallGridWidth / 2) * 2;
            var largePerRow = Math.floor(smallGridWidth / 2);

            // Starting number of large photos to make a perfect mosaic from
            var startingPoint = this.collectionQueue.length/4;
            if (_.random(0, 1) === 1) {
                startingPoint = Math.floor(startingPoint);
            } else {
                startingPoint = Math.ceil(startingPoint);
            }

            var numLargePhotos = startingPoint;
            var leftOverPhotos = 0;

            // Increment number of large photos until a perfect mosaic fit is found
            var i;
            for (i = 0; i < this.collectionQueue.length; i++) {
                numLargePhotos = startingPoint + i;
                leftOverPhotos = this.calculateMosaicFit(this.collectionQueue, numLargePhotos, smallGridWidth, largePerRow);
                if (leftOverPhotos >= 0) {
                    // Found a perfect fit for mosaic!
                    break;
                }
            }

            // Decrement number of large photos until a perfect mosaic fit is found
            if (leftOverPhotos < 0) {
                leftOverPhotos = 0;
                for (i = 1; i <= startingPoint; i++) {
                    numLargePhotos = startingPoint - i;
                    leftOverPhotos = this.calculateMosaicFit(this.collectionQueue, numLargePhotos, smallGridWidth, largePerRow);
                    if (leftOverPhotos >= 0) {
                        // Found a perfect fit for mosaic!
                        break;
                    } else if (i === startingPoint) {
                        // Can't make a perfect mosaic, load all photos
                        leftOverPhotos = 0;
                    }
                }
            }

            // Calculate number of photos to pop off the queue
            var photosToPop = this.collectionQueue.length - leftOverPhotos;

            // Get the randomized large elements
            var largeElements = this.randomizeLargePhotos(this.collectionQueue, numLargePhotos, smallGridWidth, largePerRow, photosToPop);

            // Account for large uploader tile if it exists
            var headerOptions = this.options.displayOptions.headerOptions;
            var uploaderTileExists = headerOptions && headerOptions.layout === 'tile';
            if (this.collectionQueue.currentPage === 1 && uploaderTileExists && largeElements.length > 0 && photosToPop > 1) {
                largeElements.shift();
                photosToPop--;
            }

            for (i = 0; i < photosToPop; i++) {
                var model = this.collectionQueue.shift();
                var largePhoto = _.contains(largeElements, model);
                if (largePhoto) {
                    model.set('elementSize', 'large');
                } else {
                    model.set('elementSize', 'small');
                }
                this.collection.add(model);
            }

            // Put a model in the collectionQueue to let behavior files know that the photosCollection isn't empty
            if (photosToPop > 0 && this.collectionQueue.length === 0) {
                queueModel = new Backbone.Model({
                    'queueModel': true
                });
                this.collectionQueue.add(queueModel);
            }
        },
        calculateMosaicFit: function(queue, numLargePhotos, smallGridWidth, largePerRow) {
            // Calculate the small photos needed to perfectly fit the mosaic with respect to the chosen number of largePhotos
            var smallPhotosNeeded = smallGridWidth * 2 - ((numLargePhotos % largePerRow) * 4);
            // Find out how many photos are going to be left in the collectionQueue after the calculation of smallPhotosNeeded
            var leftOverPhotos = (queue.length - numLargePhotos - smallPhotosNeeded)%smallGridWidth;
            return leftOverPhotos;
        },
        randomizeLargePhotos: function(collectionQueue, numLargePhotos, smallGridWidth, largePerRow, photosToPop) {
            // "Slice" the queue and randomly choose the large photos out of all possible options
            var bufferSpace = (photosToPop - smallGridWidth) < numLargePhotos ? largePerRow : smallGridWidth;
            var calculatedLength = photosToPop - bufferSpace;
            // calculated length has to be at least the size of the number of large photos or we won't have the right number of large photos
            calculatedLength = numLargePhotos < collectionQueue.length && calculatedLength < numLargePhotos ? numLargePhotos : calculatedLength;
            var slicedQueue = _.filter(collectionQueue.models, function(model, index) {
                if (index < calculatedLength) {
                    return true;
                }
            });
            // Pick the random largeElements out of all the possible choices
            var largeElements = _.sample(slicedQueue, numLargePhotos);
            return largeElements;
        }
    };
});
